import httpClient from "../http/http-client";
import { IInviteUserDetails } from '../users-teams/users-teams.model';
import { IPasswordDetails, IPostDisableUserId, IPostEnableUserId, IUserDetails } from './user-details.model';

export default class UserDetailsService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getUserDetails(): Promise<IUserDetails> {
    return this.http.get('user')
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      })
  }

  async getIntercomJwt(): Promise<string> {
    return this.http.get('user/intercom-jwt')
      .then(response => response.data.token)
      .catch(err => { console.log(err); throw err; })
  }

  async getAllUserDetails(queryString?: string): Promise<IUserDetails[]> {
    return this.http.get(`user/all-users${queryString ? queryString : ''}`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        console.log(err)
        throw err;
      })
  }

  async getAllUserDetailsWithPagination(status: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc', queryString?: string): Promise<{ count: number, rows: IUserDetails[] }> {
    return this.http.get(`user/all-users?status=${status}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async editUserDetails(updatedUserDetails: IUserDetails): Promise<IUserDetails> {
    return this.http.patch('user/update', updatedUserDetails)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      })
  }

  // The landing-view preference has its own endpoint: user/update guards on avatarColor and
  // defaultSubsidiaryId, which are irrelevant here. Pass null to clear it.
  async updateHomeView(homeView: string | null): Promise<{ homeView: string | null }> {
    return this.http.patch('user/home-view', { homeView })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      })
  }

  async editAnotherUserDetails(userId: string, updatedUserDetails: IInviteUserDetails): Promise<any> {
    return this.http.patch(`user/${userId}/update`, updatedUserDetails)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      })
  }

  async editPasswordDetails(updatedPasswordDetails: IPasswordDetails): Promise<IPasswordDetails> {
    return this.http.post('user/update-password', updatedPasswordDetails)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      })
  }

  async enableUser(userId: IPostEnableUserId): Promise<any> {
    return this.http.post('user/enable', userId)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      })
  }

  async disableUser(userId: string, newAssignedUser?: IPostDisableUserId): Promise<any> {
    return this.http.patch(`user/${userId}/deactivate`, newAssignedUser)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      })
  }


  async inviteUserToOrganisation(user: IInviteUserDetails): Promise<any> {
    return this.http.post('user/invite-user', user)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      })
  }

  async toggleActionsNav(): Promise<any> {
    return this.http.get('user/toggle-actions-nav')
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      })
  }

  async toggleReadinessDigest(): Promise<{ readinessDigestEnabled: boolean }> {
    return this.http.get('user/toggle-readiness-digest')
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      })
  }

  async resendInvitedUserLink(userId: string): Promise<any> {
    return this.http.post(`user/resend-invite-user-link/${userId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      })
  }
}